import { render, staticRenderFns } from "./BonusLeader.vue?vue&type=template&id=186af537&scoped=true"
import script from "./BonusLeader.vue?vue&type=script&lang=js"
export * from "./BonusLeader.vue?vue&type=script&lang=js"
import style0 from "./BonusLeader.vue?vue&type=style&index=0&id=186af537&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186af537",
  null
  
)

export default component.exports